import styled from 'styled-components';

import Button from 'components/Button';
import ImageSlider from 'components/ImageSlider';
import RichText from 'components/RichText';

import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import TYPO, { weight } from 'styles/typography';

import { isExternalLink, formatSlug } from 'utils/helpers';

const Section = styled.section`
  background-color: ${COLORS.forestDark};
  color: ${COLORS.forest};
  text-align: center;
`;

const CircleMask = styled.div`
  padding-bottom: 48px;
  width: 100%;
  border-radius: 50vw 50vw 0 0;
  background: ${COLORS.pinkMillennial}
    url('/images/backgrounds/bg-dots-pattern-forest.svg');
  background-size: 54px auto;
  overflow: hidden;

  ${BREAKPOINTS.medium`
    background-size: 63px auto;
  `}

  ${BREAKPOINTS.large`
    padding-bottom: 118px;
  `}

  /* Fix for overflow hidden with border-radius in Safari */
  transform: translateZ(0) translateY(1px);
`;

const H3 = styled.h3`
  ${TYPO.h3}
  margin: 96px auto 10px;
  padding: 0 25px;
  font-weight: ${weight.bold};

  ${BREAKPOINTS.medium`
    margin: 140px auto 40px;
    font-weight: ${weight.black};
    letter-spacing: -0.02em;
  `}

  ${BREAKPOINTS.large`
    margin-top: 200px;
  `}
`;

const RichTextStyled = styled(RichText)`
  ${TYPO.p1}
  margin: 0 auto 25px;
  padding: 0 25px;
  max-width: 490px;
  opacity: 0.8;

  ${BREAKPOINTS.medium`
    margin-bottom: 20px;
  `}
`;

const A = styled.a`
  ${TYPO.p1}
  margin-top: 20px;
  display: inline-block;
  font-weight: ${weight.semibold};
  opacity: 0.8;
`;

const ImageSliderStyled = styled(ImageSlider)`
  margin-top: 56px;
`;

const PromotionsBanner = ({ data, claysLocation }) => {
  const { title, description, callToAction, pdfDownload, imageSlider } = data;
  return (
    <Section>
      <CircleMask>
        <H3 small>{title}</H3>
        <RichTextStyled html={description?.html} />

        {callToAction && (
          <Button
            href={
              isExternalLink(callToAction.link)
                ? callToAction.link
                : `/${formatSlug(claysLocation)}${callToAction.link}`
            }
          >
            {callToAction.label}
          </Button>
        )}

        {pdfDownload && (
          <div>
            <A
              href={pdfDownload.pdfAsset.url}
              target="_blank"
              rel="noreferrer"
              download
            >
              {pdfDownload.label}
            </A>
          </div>
        )}

        <ImageSliderStyled images={imageSlider.images} />
      </CircleMask>
    </Section>
  );
};

export default PromotionsBanner;
